import {
  APPINFO_SUCCESS,
  CREATEZONE_SUCCESS,
  UPDATEZONE_SUCCESS,
  FETCHZONES_SUCCESS,
  DELETEZONE_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  zones: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCHZONES_SUCCESS: {
      return {
        ...state,
        zones: {
            ...state.zones,
            [action.applicationId]: action.payload.getZones
        }
      }
    }

    case CREATEZONE_SUCCESS: {
      return {
        ...state,
        createdZone: action.payload
      }
    }

    case UPDATEZONE_SUCCESS: {
      return {
        ...state,
        updatedZone: action.payload
      }
    }

    case DELETEZONE_SUCCESS: {

      return {
        ...state,
        deleted: action.payload,
      }
    }

    default:
      return {
        ...state,
        updatedZone: false,
        deleted: false
      }
  }
}
